import { html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import { filter } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/collection-helpers.js';
/**
 * @param element The checkgroup/radiogroup element.
 * @returns The template containing check/radio items that will be rendered to shadow DOM.
 */
export const renderItems = (element) => {
    /*
      Does not use properties to avoid delay in attribute to property mapping,
      which runs in custom element reaction cycle:
      https://html.spec.whatwg.org/multipage/custom-elements.html#custom-element-reactions
  
      'Node.nodeType' property is an integer that identifies what the node is
      'Node.ELEMENT_NODE' is an Element node like <p> or <div>.
      https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    */
    return html `${filter(element.childNodes, (item) => item.nodeType === Node.ELEMENT_NODE).map((item, index) => {
        const autofocus = item.hasAttribute('autofocus');
        const checked = item.hasAttribute('checked');
        const disabled = item.hasAttribute('disabled');
        const value = item.getAttribute('value');
        const { textContent } = item;
        const getDisabledStatus = () => element.disabled ? true : disabled;
        const name = 'checkitem';
        if (item.matches('cipublic-checkitem')) {
            const idName = `${name}-${index}`;
            return html `<div class="item"><input ?autofocus="${autofocus}" .checked="${getDisabledStatus() ? false : checked}" ?disabled="${getDisabledStatus()}" id="${idName}" name="${element.name}" type="checkbox" value="${ifDefined(value)}" @blur="${((event) => {
                emit(element, `${name}.blur`, { detail: { element: event.target } });
            })}" @change="${((event) => {
                emit(element, `${name}.change`, { detail: { element: event.target } });
            })}" @click="${(event) => {
                /*
                  The blur event doesn't fire on checkboxes and radio buttons in some browsers (safari).
                  Workaround involves manually setting the focus on the element to trigger blur when clicked out
                  https://stackoverflow.com/a/5745104
                */
                event.target.focus();
                emit(element, `${name}.click`, { detail: { element: event.target } });
            }}"> <label for="${idName}">${textContent}</label></div>`;
        }
        return;
    })}`;
};
//# sourceMappingURL=generate-elements.js.map